/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApproveTenantRelationshipRequest,
  CreateTenantRelationshipRequest,
  RejectTenantRelationshipRequest,
  RevokeTenantRelationshipRequest,
  TenantRelationshipListResponse,
  TenantRelationshipResponse,
} from '../models/index';
import {
    ApproveTenantRelationshipRequestFromJSON,
    ApproveTenantRelationshipRequestToJSON,
    CreateTenantRelationshipRequestFromJSON,
    CreateTenantRelationshipRequestToJSON,
    RejectTenantRelationshipRequestFromJSON,
    RejectTenantRelationshipRequestToJSON,
    RevokeTenantRelationshipRequestFromJSON,
    RevokeTenantRelationshipRequestToJSON,
    TenantRelationshipListResponseFromJSON,
    TenantRelationshipListResponseToJSON,
    TenantRelationshipResponseFromJSON,
    TenantRelationshipResponseToJSON,
} from '../models/index';

export interface ApproveRelationshipRequest {
    sessionId: string;
    relationshipId: string;
    approveTenantRelationshipRequest: ApproveTenantRelationshipRequest;
}

export interface CreateTenantRelationshipWithSessionRequest {
    sessionId: string;
    createTenantRelationshipRequest: CreateTenantRelationshipRequest;
}

export interface GetRelationshipRequest {
    sessionId: string;
    relationshipId: string;
}

export interface ListPendingApprovalsRequest {
    sessionId: string;
    tenantIds?: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
}

export interface ListRelationshipsRequest {
    sessionId: string;
    tenantIds?: string;
    page?: string;
    pageSize?: string;
    sortBy?: string;
    sortOrder?: string;
}

export interface RejectRelationshipRequest {
    sessionId: string;
    relationshipId: string;
    rejectTenantRelationshipRequest: RejectTenantRelationshipRequest;
}

export interface RevokeRelationshipRequest {
    sessionId: string;
    relationshipId: string;
    revokeTenantRelationshipRequest: RevokeTenantRelationshipRequest;
}

/**
 * TenantRelationshipsApi - interface
 * 
 * @export
 * @interface TenantRelationshipsApiInterface
 */
export interface TenantRelationshipsApiInterface {
    /**
     * Approve a pending relationship request. Only the target tenant can approve requests.
     * @summary Approve a pending tenant relationship
     * @param {string} sessionId Session ID for authentication and tenant context
     * @param {string} relationshipId ID of the relationship to approve
     * @param {ApproveTenantRelationshipRequest} approveTenantRelationshipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRelationshipsApiInterface
     */
    approveRelationshipRaw(requestParameters: ApproveRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipResponse>>;

    /**
     * Approve a pending relationship request. Only the target tenant can approve requests.
     * Approve a pending tenant relationship
     */
    approveRelationship(requestParameters: ApproveRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipResponse>;

    /**
     * Create a formal relationship request between two tenants. The target tenant must approve the request.
     * @summary Create a new tenant relationship request
     * @param {string} sessionId Session ID for authentication and tenant context
     * @param {CreateTenantRelationshipRequest} createTenantRelationshipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRelationshipsApiInterface
     */
    createTenantRelationshipWithSessionRaw(requestParameters: CreateTenantRelationshipWithSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipResponse>>;

    /**
     * Create a formal relationship request between two tenants. The target tenant must approve the request.
     * Create a new tenant relationship request
     */
    createTenantRelationshipWithSession(requestParameters: CreateTenantRelationshipWithSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipResponse>;

    /**
     * Retrieve details of a specific tenant relationship. Only participating tenants can view the relationship.
     * @summary Get a specific tenant relationship
     * @param {string} sessionId Session ID for authentication and tenant context
     * @param {string} relationshipId ID of the relationship to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRelationshipsApiInterface
     */
    getRelationshipRaw(requestParameters: GetRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipResponse>>;

    /**
     * Retrieve details of a specific tenant relationship. Only participating tenants can view the relationship.
     * Get a specific tenant relationship
     */
    getRelationship(requestParameters: GetRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipResponse>;

    /**
     * List all pending relationship requests where the current tenant is the target.
     * @summary List pending approval requests
     * @param {string} sessionId Session ID for authentication and tenant context
     * @param {string} [tenantIds] Tenant IDs to filter by (optional)
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRelationshipsApiInterface
     */
    listPendingApprovalsRaw(requestParameters: ListPendingApprovalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipListResponse>>;

    /**
     * List all pending relationship requests where the current tenant is the target.
     * List pending approval requests
     */
    listPendingApprovals(requestParameters: ListPendingApprovalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipListResponse>;

    /**
     * List all relationships for the current tenant (both as source and target).
     * @summary List tenant relationships
     * @param {string} sessionId Session ID for authentication and tenant context
     * @param {string} [tenantIds] Tenant IDs to filter by (optional)
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sortBy] Sort field
     * @param {string} [sortOrder] Sort order (asc/desc)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRelationshipsApiInterface
     */
    listRelationshipsRaw(requestParameters: ListRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipListResponse>>;

    /**
     * List all relationships for the current tenant (both as source and target).
     * List tenant relationships
     */
    listRelationships(requestParameters: ListRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipListResponse>;

    /**
     * Reject a pending relationship request. Only the target tenant can reject requests.
     * @summary Reject a pending tenant relationship
     * @param {string} sessionId Session ID for authentication and tenant context
     * @param {string} relationshipId ID of the relationship to reject
     * @param {RejectTenantRelationshipRequest} rejectTenantRelationshipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRelationshipsApiInterface
     */
    rejectRelationshipRaw(requestParameters: RejectRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipResponse>>;

    /**
     * Reject a pending relationship request. Only the target tenant can reject requests.
     * Reject a pending tenant relationship
     */
    rejectRelationship(requestParameters: RejectRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipResponse>;

    /**
     * Revoke an active relationship. This will automatically revoke all cross-tenant user roles enabled by this relationship.
     * @summary Revoke an active tenant relationship
     * @param {string} sessionId Session ID for authentication and tenant context
     * @param {string} relationshipId ID of the relationship to revoke
     * @param {RevokeTenantRelationshipRequest} revokeTenantRelationshipRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantRelationshipsApiInterface
     */
    revokeRelationshipRaw(requestParameters: RevokeRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipResponse>>;

    /**
     * Revoke an active relationship. This will automatically revoke all cross-tenant user roles enabled by this relationship.
     * Revoke an active tenant relationship
     */
    revokeRelationship(requestParameters: RevokeRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipResponse>;

}

/**
 * 
 */
export class TenantRelationshipsApi extends runtime.BaseAPI implements TenantRelationshipsApiInterface {

    /**
     * Approve a pending relationship request. Only the target tenant can approve requests.
     * Approve a pending tenant relationship
     */
    async approveRelationshipRaw(requestParameters: ApproveRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling approveRelationship().'
            );
        }

        if (requestParameters['relationshipId'] == null) {
            throw new runtime.RequiredError(
                'relationshipId',
                'Required parameter "relationshipId" was null or undefined when calling approveRelationship().'
            );
        }

        if (requestParameters['approveTenantRelationshipRequest'] == null) {
            throw new runtime.RequiredError(
                'approveTenantRelationshipRequest',
                'Required parameter "approveTenantRelationshipRequest" was null or undefined when calling approveRelationship().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-relationships/{relationshipId}/approve`;
        urlPath = urlPath.replace(`{${"relationshipId"}}`, encodeURIComponent(String(requestParameters['relationshipId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ApproveTenantRelationshipRequestToJSON(requestParameters['approveTenantRelationshipRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantRelationshipResponseFromJSON(jsonValue));
    }

    /**
     * Approve a pending relationship request. Only the target tenant can approve requests.
     * Approve a pending tenant relationship
     */
    async approveRelationship(requestParameters: ApproveRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipResponse> {
        const response = await this.approveRelationshipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a formal relationship request between two tenants. The target tenant must approve the request.
     * Create a new tenant relationship request
     */
    async createTenantRelationshipWithSessionRaw(requestParameters: CreateTenantRelationshipWithSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling createTenantRelationshipWithSession().'
            );
        }

        if (requestParameters['createTenantRelationshipRequest'] == null) {
            throw new runtime.RequiredError(
                'createTenantRelationshipRequest',
                'Required parameter "createTenantRelationshipRequest" was null or undefined when calling createTenantRelationshipWithSession().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-relationships`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateTenantRelationshipRequestToJSON(requestParameters['createTenantRelationshipRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantRelationshipResponseFromJSON(jsonValue));
    }

    /**
     * Create a formal relationship request between two tenants. The target tenant must approve the request.
     * Create a new tenant relationship request
     */
    async createTenantRelationshipWithSession(requestParameters: CreateTenantRelationshipWithSessionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipResponse> {
        const response = await this.createTenantRelationshipWithSessionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve details of a specific tenant relationship. Only participating tenants can view the relationship.
     * Get a specific tenant relationship
     */
    async getRelationshipRaw(requestParameters: GetRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling getRelationship().'
            );
        }

        if (requestParameters['relationshipId'] == null) {
            throw new runtime.RequiredError(
                'relationshipId',
                'Required parameter "relationshipId" was null or undefined when calling getRelationship().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-relationships/{relationshipId}`;
        urlPath = urlPath.replace(`{${"relationshipId"}}`, encodeURIComponent(String(requestParameters['relationshipId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantRelationshipResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve details of a specific tenant relationship. Only participating tenants can view the relationship.
     * Get a specific tenant relationship
     */
    async getRelationship(requestParameters: GetRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipResponse> {
        const response = await this.getRelationshipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all pending relationship requests where the current tenant is the target.
     * List pending approval requests
     */
    async listPendingApprovalsRaw(requestParameters: ListPendingApprovalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipListResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling listPendingApprovals().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-relationships/pending-approvals`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantRelationshipListResponseFromJSON(jsonValue));
    }

    /**
     * List all pending relationship requests where the current tenant is the target.
     * List pending approval requests
     */
    async listPendingApprovals(requestParameters: ListPendingApprovalsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipListResponse> {
        const response = await this.listPendingApprovalsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all relationships for the current tenant (both as source and target).
     * List tenant relationships
     */
    async listRelationshipsRaw(requestParameters: ListRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipListResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling listRelationships().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['tenantIds'] != null) {
            queryParameters['tenantIds'] = requestParameters['tenantIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-relationships`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantRelationshipListResponseFromJSON(jsonValue));
    }

    /**
     * List all relationships for the current tenant (both as source and target).
     * List tenant relationships
     */
    async listRelationships(requestParameters: ListRelationshipsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipListResponse> {
        const response = await this.listRelationshipsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Reject a pending relationship request. Only the target tenant can reject requests.
     * Reject a pending tenant relationship
     */
    async rejectRelationshipRaw(requestParameters: RejectRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling rejectRelationship().'
            );
        }

        if (requestParameters['relationshipId'] == null) {
            throw new runtime.RequiredError(
                'relationshipId',
                'Required parameter "relationshipId" was null or undefined when calling rejectRelationship().'
            );
        }

        if (requestParameters['rejectTenantRelationshipRequest'] == null) {
            throw new runtime.RequiredError(
                'rejectTenantRelationshipRequest',
                'Required parameter "rejectTenantRelationshipRequest" was null or undefined when calling rejectRelationship().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-relationships/{relationshipId}/reject`;
        urlPath = urlPath.replace(`{${"relationshipId"}}`, encodeURIComponent(String(requestParameters['relationshipId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RejectTenantRelationshipRequestToJSON(requestParameters['rejectTenantRelationshipRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantRelationshipResponseFromJSON(jsonValue));
    }

    /**
     * Reject a pending relationship request. Only the target tenant can reject requests.
     * Reject a pending tenant relationship
     */
    async rejectRelationship(requestParameters: RejectRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipResponse> {
        const response = await this.rejectRelationshipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Revoke an active relationship. This will automatically revoke all cross-tenant user roles enabled by this relationship.
     * Revoke an active tenant relationship
     */
    async revokeRelationshipRaw(requestParameters: RevokeRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TenantRelationshipResponse>> {
        if (requestParameters['sessionId'] == null) {
            throw new runtime.RequiredError(
                'sessionId',
                'Required parameter "sessionId" was null or undefined when calling revokeRelationship().'
            );
        }

        if (requestParameters['relationshipId'] == null) {
            throw new runtime.RequiredError(
                'relationshipId',
                'Required parameter "relationshipId" was null or undefined when calling revokeRelationship().'
            );
        }

        if (requestParameters['revokeTenantRelationshipRequest'] == null) {
            throw new runtime.RequiredError(
                'revokeTenantRelationshipRequest',
                'Required parameter "revokeTenantRelationshipRequest" was null or undefined when calling revokeRelationship().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/v1/tenant-relationships/{relationshipId}/revoke`;
        urlPath = urlPath.replace(`{${"relationshipId"}}`, encodeURIComponent(String(requestParameters['relationshipId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: RevokeTenantRelationshipRequestToJSON(requestParameters['revokeTenantRelationshipRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TenantRelationshipResponseFromJSON(jsonValue));
    }

    /**
     * Revoke an active relationship. This will automatically revoke all cross-tenant user roles enabled by this relationship.
     * Revoke an active tenant relationship
     */
    async revokeRelationship(requestParameters: RevokeRelationshipRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TenantRelationshipResponse> {
        const response = await this.revokeRelationshipRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
